import { ref } from "vue-demi";
const useDeviceStore = () => {
  const deviceStore = ref({
    device: null
  });
  const getUserDevice = () => deviceStore.value.device;
  const setUserDevice = (device) => deviceStore.value.device = device;
  const isPc = () => getUserDevice() === "pc";
  return {
    deviceStore,
    getUserDevice,
    setUserDevice,
    isPc
  };
};
export default useDeviceStore;
